// extracted by mini-css-extract-plugin
export default {"subHeader":"SetUpDrawer_subHeader__+OUPC","addViewBtn":"SetUpDrawer_addViewBtn__TkGcG"};